import {array, string, type, TypeOf} from 'io-ts';

export const ServiceOptionSchema = type({
    name: string,
    key: string,
    icon: string,
});

export const AccountSchema = type({
    services: array(ServiceOptionSchema),
});
export type AccountSchema = TypeOf<typeof AccountSchema>;
